import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------
export const StyledContentArea = styled(Box)`
  // Top - level padded container
  & > .block-container.with-padding:not(.no-added-padding) {
    padding-top: 16px;
    padding-bottom: 16px;
    ${breakpoints.up('md')} {
      padding-top: 32px;
      padding-bottom: 32px;
    }
    &:first-of-type:not(.no-added-padding) {
      padding-top: 32px;
      // ${breakpoints.up('md')} {
      //   padding-top: 64px;
      // }
    }
    &:last-of-type:not(.no-added-padding) {
      padding-bottom: 32px;
      // ${breakpoints.up('md')} {
      //   padding-bottom: 64px;
      // }
    }
  }

  // Top - level fullscreen container
  & > .block-container.fullscreen {
  }

  // Padded container after fullscreen - doubled padding
  .block-container.fullscreen + .block-container.with-padding {
    padding-top: 32px;
    // ${breakpoints.up('md')} {
    //   padding-top: 64px;
    // }
  }

  // Fullscreen container after padded - increased padding
  .block-container.with-padding + .block-container.fullscreen {
    padding-top: 16px;
    // ${breakpoints.up('md')} {
    //   padding-top: 32px;
    // }
  }
`;
